export const actionPlan = {
  unity: "{{idUnity}} - {{storeName}}",
  'areYouSureWantDeleteAllPlansSelected_one': '¿Estás seguro que deseas eliminar este plan de acción?',
  'areYouSureWantDeleteAllPlansSelected_other': '¿Estás seguro que deseas eliminar los planes de acción seleccionados?',
  'areYouSureWantDeleteThisPlanSelected': '¿Estás seguro que deseas eliminar este plan de acción?',
  toDeleteTheSelectedPlans: 'Al eliminar un plan, se borrará de tu lista y debes realizar nuevamente su configuración.',
  "goBack": "Regresar a la lista de planes de acción",
  "title": "Planes de acción",
  byUsers: 'Por usuarios',
  solutionDate: "Tiempo máximo de solución: {{date}}",
  byStores: 'Por unidades',
  successDownloadReport: 'El reporte se descargó exitosamente.',
  errorDownloadReport: 'Ocurrió un error al descargar el reporte.',
  actionPlanResponse: 'Respuestas del plan',
  aprovers: 'Usuarios aprobadores',
  approveAssigned: 'Se reasignaron los usuarios exitosamente',
  emitBy: 'Emitida por',
  rejectBy: 'Rechazado por',
  aproveBy: 'Usuario aprobador',
  generatedBy: 'Usuario asignador',
  referencedStore: 'Unidad referenciada',
  userSolver: 'Usuario asignado',
  responseDetail: 'Detalle de respuesta',
  rejectMotive: 'Motivo de rechazo',
  evidenceList: 'Listado de evidencias',
  noActionPlan: 'Aún no se han recibido respuestas en este plan de acción',
  timeOut: "Han pasado {{time}} horas y no se han obtenido respuestas de los usuarios aprobadores",
  reassignActionPlan: 'Reasignar plan de acción',
  noAprovers: 'Aún no se han asignado usuarios aprobadores',
  "modal": {
    "title": "Por favor indique el motivo de su rechazo",
    "label": "Motivo del rechazo",
    "cancel": "¿Estás seguro que deseas cancelar este plan de acción?"
  },
  approverTitle: '¿Estás seguro que deseas que los usuarios seleccionados puedan aprobar este plan de acción?',
  approverNotSelecets: 'No hay usuarios seleccionados',
  approverDescription: '',
  tabs: {
    evidence: 'Evidencias',
    item: 'Items'
  },
  "actionPlanOf": {
    "stores": "Por unidades",
    "users": "Por usuarios"
  },
  "snackbar": {
    'selectAtLeastOnePlan': 'Debes seleccionar al menos un plan de acción para realizar esta acción',
    "cancel": {
      "success": "El plan de acción se cancelo exitosamente",
      "error": "Ocurrió un error al cancelar el plan de acción"
    },
    "approved": {
      "success": "El plan de acción se aprobó exitosamente",
      "error": "Ocurrió un error al aprobar el plan de acción"
    },
    "reject": {
      "success": "El plan de acción se rechazó exitosamente",
      "error": "Ocurrió un error al rechazar el plan de acción"
    },
    "delete": {
      "error": {
        "unique": "No se pudo eliminar el plan de acción.",
        "masive": "No se pudieron eliminar los planes de acción seleccionados."
      },
      "success": {
        "unique": "El plan de acción se eliminó correctamente.",
        "masive": "Los planes de acción seleccionados se eliminaron correctamente."
      }
    },
  },
  tags: {
    timeRemaining: 'Tiempo restante',
    assignedUser: 'Usuario asignado',
    assigningUser: 'Usuario asignador',
    idUnity: 'ID - Unidad',
    days: 'Días',
    hours: 'Horas',
    minutes: 'Minutos',
    seconds: 'Segundos',
    gestionType: 'Tipo de gestión',
  }
}